import React from 'react';

const statusConfig = {
  active: { bg: 'bg-emerald-100', text: 'text-emerald-700', label: 'Active' },
  inactive: { bg: 'bg-gray-100', text: 'text-gray-600', label: 'Inactive' },
  pending: { bg: 'bg-amber-100', text: 'text-amber-700', label: 'Pending' },
  completed: { bg: 'bg-emerald-100', text: 'text-emerald-700', label: 'Completed' },
  cancelled: { bg: 'bg-red-100', text: 'text-red-700', label: 'Cancelled' },
  deleted: { bg: 'bg-red-100', text: 'text-red-700', label: 'Deleted' },
  paid: { bg: 'bg-emerald-100', text: 'text-emerald-700', label: 'Paid' },
  unpaid: { bg: 'bg-red-100', text: 'text-red-700', label: 'Unpaid' },
  partial: { bg: 'bg-amber-100', text: 'text-amber-700', label: 'Partial' },
  delivered: { bg: 'bg-emerald-100', text: 'text-emerald-700', label: 'Delivered' },
  in_transit: { bg: 'bg-blue-100', text: 'text-brand', label: 'In Transit' },
  default: { bg: 'bg-gray-100', text: 'text-gray-700', label: '' },
};

const variantConfig = {
  success: { bg: 'bg-emerald-100', text: 'text-emerald-700' },
  danger: { bg: 'bg-red-100', text: 'text-red-700' },
  warning: { bg: 'bg-amber-100', text: 'text-amber-700' },
  info: { bg: 'bg-blue-100', text: 'text-brand' },
  default: { bg: 'bg-gray-100', text: 'text-gray-700' },
};

const StatusBadge = ({ status, variant, label, className = '' }) => {
  const normalizedStatus = status?.toLowerCase?.().replace(/\s+/g, '_');
  const config = variant
    ? { ...variantConfig[variant] || variantConfig.default, label: label || status }
    : statusConfig[normalizedStatus] || {
        ...statusConfig.default,
        label: label || (status ? status.charAt(0).toUpperCase() + status.slice(1).toLowerCase() : 'Unknown'),
      };

  return (
    <span
      className={`
        inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium
        ${config.bg} ${config.text} ${className}
      `}
    >
      {config.label}
    </span>
  );
};

export default StatusBadge;
